import type { Heading } from '../types/hero'

export const strangewaysCaHeading: Heading = {
    heading: "Recording & rehearsal studio",
    paragraph: "Strangeways is a turnkey recording and rehearsal studio on Vancouver Island.",
    image: "strangeways_2025"
}

export const strangewaysCaSubheading: string[] = [
    "Optimised for independent artists",
    "Pristine multitrack audio + HD video",
    "Remote collaboration via Sessionwire"
]

export const strangewaysDevHeading: Heading = {
    heading: "Software development",
    paragraph: "Strangeways.dev is a software engineering agency.",
    image: "coder-at-desk"
}

export const strangewaysDevSubheading: string[] = [
    "Full-stack web & mobile development",
    "AI/ML integration & automation",
    "Scalable business architecture"
]